import { render, staticRenderFns } from "./PreviousLaborData.vue?vue&type=template&id=c29e56a0&scoped=true&"
import script from "./PreviousLaborData.vue?vue&type=script&lang=ts&"
export * from "./PreviousLaborData.vue?vue&type=script&lang=ts&"
import style0 from "./PreviousLaborData.vue?vue&type=style&index=0&id=c29e56a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c29e56a0",
  null
  
)

export default component.exports